<template>
  <b-form-group
    label="Telefon"
    label-for="phone"
  >
    <b-form-input
      id="phone"
      v-model="dataItem.phone"
      placeholder="Telefon"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'PhoneNumber',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['workers/dataItem']
    },
  },
}
</script>
